<template>
  <div class="login-page">
    <div class="login-container">
      <div class="left-panel">
        <div class="left-inner">
          <v-row class="ma-0" justify="center" style="max-height: 125px">
            <div style="width:100%">
              <v-img :src="images.new_logo_W" width=360></v-img>
            </div>
          </v-row>
          <div class="system-title">
            教職員薪資<br />查詢系統
          </div>
        </div>
        <div class="left-contrary">
          <div id="box2" class="px-2 py-12" style="background:#FFF; border-radius: 26px; z-index:2">
            <v-row class="mt-2" justify="center">
              <v-col class="py-0 col-11 col-sm-10 col-md-9 col-lg-8">
                <v-row class="ma-0 pb-8" justify="center">
                  <div>
                    <v-img :src="images.new_logo" width=240></v-img>
                  </div>
                </v-row>
                <v-row class="ma-0">
                  <div class="mr-3 firstBar"></div>
                  <h4 style="font-size:20px; color:#000">教職員薪資查詢系統</h4>
                </v-row>
                <div class="text-left pt-6 pt14" style="color:#000">帳號</div>
                <v-text-field class="mt-2 border pt14" dense background-color="white" outlined placeholder="請輸入帳號" maxlength="50" v-model="account"
                @keyup="account = account.replace(/[\u4e00-\u9fa5]/ig,''), account = $Global.toCDB(account)"></v-text-field>
                <div class="text-left pt-2 pt14" style="color:#000">密碼</div>
                <v-text-field class="mt-2 border pt14" dense background-color="white" type="password" outlined placeholder="請輸入密碼" maxlength="50" v-model="password"
                @keyup="password = password.replace(/[\u4e00-\u9fa5]/ig,''), password = $Global.toCDB(password)" @keyup.enter="login()"></v-text-field>
                <div style="height:42px"><h4 class="pt-2 text-left" style="font-size:14px; color:#FF5A5A" v-if="isError">帳號密碼輸入錯誤 !</h4></div>
                <VueLoadingButton aria-label="Post message" class="mb-5 search-bar-btn button" style="width:45%; height:40px; background:#002C61; border-radius:100px; border:none"
                  @click.native="login()" :loading="isLoading">
                  <span style="color:#FFFFFF; font-size: 0.875rem">登入</span>
                </VueLoadingButton>
              </v-col>
            </v-row>
          </div>
        </div>
        <img :src="images.login_material1" class="deco-arrow" />
        <img :src="images.login_material2" class="deco-dots" />
      </div>

      <div class="right-panel">
        <div id="box2" class="px-2 py-12" style="background:#FFF; border-radius: 26px">
          <v-row class="mt-2" justify="center">
            <v-col class="py-0 col-11 col-sm-10 col-md-9 col-lg-8">
              <v-row class="ma-0 mt-8">
                <div class="mr-3 firstBar"></div>
                <h4 style="font-size:20px">登入帳號</h4>
              </v-row>
              <div class="text-left pt-6 pt14">帳號</div>
              <v-text-field class="mt-2 border pt14" dense background-color="white" outlined placeholder="請輸入帳號" maxlength="50" v-model="account"
              @keyup="account = account.replace(/[\u4e00-\u9fa5]/ig,''), account = $Global.toCDB(account)"></v-text-field>
              <div class="text-left pt-2 pt14">密碼</div>
              <v-text-field class="mt-2 border pt14" dense background-color="white" type="password" outlined placeholder="請輸入密碼" maxlength="50" v-model="password"
              @keyup="password = password.replace(/[\u4e00-\u9fa5]/ig,''), password = $Global.toCDB(password)" @keyup.enter="login()"></v-text-field>
              <div style="height:42px"><h4 class="pt-2 text-left" style="font-size:14px; color:#FF5A5A" v-if="isError">帳號密碼輸入錯誤 !</h4></div>
              <VueLoadingButton aria-label="Post message" class="mb-5 search-bar-btn button" style="width:45%; height:40px; background:#002C61; border-radius:100px; border:none"
                @click.native="login()" :loading="isLoading">
                <span style="color:#FFFFFF; font-size: 0.875rem">登入</span>
              </VueLoadingButton>
            </v-col>
          </v-row>
        </div>
        <img :src="images.login_material3" class="deco-wave" />
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js"
import VueLoadingButton from 'vue-loading-button';

export default {
  name: 'Login',
  components: {VueLoadingButton},
  data:()=>({
    viewStyle:{},
    images:{
      login_material1: require('@/assets/image/login_material1.png'),
      login_material2: require('@/assets/image/login_material2.png'),
      login_material3: require('@/assets/image/login_material3.png'),
      new_logo: require('@/assets/image/logo.png'),
      new_logo_W: require('@/assets/image/logo-W.png'),
    },
    account:'',
    password:'',
    isLoading: false,
    isError:false
  }),
  mounted(){
    this.calculateWindows()
    window.onresize = () => {
      this.calculateWindows()
    }
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight + 'px'}
    },
    redirectPath(path, type){
      this.$router.push({path: path, query: {type: type}})
    },
    login(){
      this.isError = false //resrt status
      if(!this.account||!this.password){
        this.isError = true
        return
      }

      this.isLoading = true
      var self = this
      var request = {
          method: 'POST',
          url: '/pmMemberLogin',
          data: this.Qs.stringify({
            userId: this.account,
            // passwd: this.password,
            passwd: CryptoJS.MD5(this.password).toString(),
          }),
      }
      this.$http(request).then(function(response) {
        // console.log('message: ' + response.data.data.message)
        if(response.data.data.message == '很抱歉, 您的帳號已停用, 請聯絡管理員~'){
          self.$refs.ShowMsg.open(0,'登入失敗',response.data.data.message)
        }
        sessionStorage.setItem('manageMemberToken', response.data.data.token)
        sessionStorage.setItem('manageMemberUserId',response.data.data.userId)
        sessionStorage.setItem('manageMemberName',response.data.data.userName)
        sessionStorage.setItem('manageMemberSysId',response.data.data.id)
        self.$root.LOGININFO = {
          name:response.data.data.username
        }
        if(response.data.data.message == '登入成功'){
          if(self.account == self.password){
            self.redirectPath('/home', 'same')
          }else{
            self.redirectPath('/home')
          }
        }
      }).catch(()=>{
        self.isError = true
      }).finally(function() {
        self.isLoading = false
        // setTimeout(() => (self.isLoading = false), 5000)
      })
    },
  }
}
</script>


<style>
  @media (max-width: 959px) {
    .col-xs-0 {
      display: none;
    }
    .hamburger {
      display: unset !important;
      width: 50px !important;
    }
    .breadcrumb, .headerName, .app-content-left {
      display: none !important;
    }
  }
  .login-page {
    height: 100vh;
    overflow: hidden;
  }
  .login-container {
    display: flex;
    height: 100%;
  }
  .left-panel {
    width: 50%;
    background: #173A6A;
    color: #fff;
    position: relative;
  }
  .left-inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .left-contrary{
    display: none;
  }
  .system-title {
    font-size: 3.8rem;
    font-weight: 500;
    text-align: center;
    line-height: 5rem;
    margin-bottom: 50px;
  }
  .right-panel {
    width: 50%;
    background: #F5F6F8;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .right-panel::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 300px;
    height: 200px;
    background: url('/wave.svg') no-repeat;
    background-size: contain;
  }
  .left-panel, .right-panel {
    position: relative;
  }
  .deco-arrow {
    position: absolute;
    top: 0px;
    right: 10px;
    width: 150px;
  }
  .deco-dots {
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 250px;
  }
  .deco-wave {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 500px;
    pointer-events: none; /* 很重要 */
  }

  /* ======================
    📱 手機版（最重要）
  ====================== */
  @media (max-width: 768px) {
    .login-container {
      flex-direction: column;
    }
    .left-panel {
      width: 100%;
      height: 100%;
    }
    .right-panel {
      position: absolute;
      width: 100%;
      height: 100%;
      background: transparent;
      display: none !important;
    }
    .system-title {
      font-size: 24px;
    }
    .left-inner{
      display: none !important;
    }
    .left-contrary{
      display: block;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .deco-arrow {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 90px;
    }
    .deco-dots {
      position: absolute;
      bottom: -10px;
      left: 0px;
      width: 160px;
    }
    .deco-wave {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 620px;
      pointer-events: none; /* 很重要 */
    }
  }
</style>

